<!--零用钱-->
<template>
    <div>
        <van-nav-bar :title="title"  >
        </van-nav-bar>
        <div class="pm-panel" >

            <van-cell-group>
                <van-field
                        :required=true
                        :border=false
                        readonly
                        clickable
                        label="日期"
                        :value="formModel.pmDate"
                        placeholder="请选择"
                        @click="showDatePicker = true"
                />
                <van-popup v-model="showDatePicker" position="bottom">
                    <van-datetime-picker
                            v-model="pickDate"
                            type="date"
                            :min-date="minDate"
                            :max-date="maxDate"
                            @cancel="showDatePicker = false"
                            @confirm="onDateConfirm"
                    />
                </van-popup>
            </van-cell-group>
            <van-cell-group>
                <van-field
                        readonly
                        :required=true
                        clickable
                        label="时间"
                        :value="formModel.pmTime"
                        placeholder="请选择"
                        @click="showTimePicker = true"
                />
                <van-popup v-model="showTimePicker" position="bottom">
                    <van-datetime-picker
                            v-model="pickTime"
                            type="time"
                            :min-hour="0"
                            :max-hour="24"
                            @cancel="showTimePicker = false"
                            @confirm="onTimeConfirm"
                    />
                </van-popup>
            </van-cell-group>

            <van-cell-group>
                <van-field
                        readonly
                        clickable
                        label="归属/分类"
                        :value="belongFinType"
                        placeholder="请选择"
                        @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                    <van-picker
                            show-toolbar title="归属/分类" ref="belongPicker"
                            :columns="belongFinTypes"
                            value-key="attrName"
                            @cancel="showPicker = false"
                            @confirm="onConfirm"
                    />
                </van-popup>
            </van-cell-group>

            <van-cell-group>
                <van-field  readonly
                            type="text" label="金额"
                            placeholder="请录入金额"
                            :required=true
                            clickable
                            :value="formModel.amount"
                            @touchstart.native.stop="showKeyboard = true"
                />
                <van-number-keyboard
                        :show="showKeyboard"
                        v-model="formModel.amount"
                        extra-key="."
                        close-button-text="完成"
                        @blur="showKeyboard = false"
                />
            </van-cell-group>
            <van-cell-group>
                <van-field
                        v-model="formModel.remark"
                        rows="2"
                        autosize
                        label="备注"
                        type="textarea"
                        maxlength="50"
                        placeholder="请输入备注"
                        show-word-limit
                />
            </van-cell-group>
            <van-cell-group v-show="checkUser()">
              <van-cell title="基金" is-link to="stock" />
            </van-cell-group>
            <van-cell-group>
                <van-button style="margin-top: 10px;" type="primary"
                            block round color="#fe7844" :loading="isLoading"
                            loading-text="提交中..."
                            @click="submitForm">提交</van-button>
            </van-cell-group>

        </div>
    </div>

</template>

<script>


    import * as MyApi from '../../api/URLApiAddr.js'
    import * as DateUtil from "../../common/utils/dateUtil";
    import store from "@/store";
    import * as BusiConsts from "@/common/BusiConsts";

    export default {
        name: "PocketMoney",
        data() {
            return {
                title: '零花钱',
                formModel: {
                    id:'',
                    roleId: '',
                    amount: '',
                    remark: '',
                    pmDate:DateUtil.formatDate(new Date,'yyyy-MM-dd'),
                    pmTime:DateUtil.formatDate(new Date,'hh:mm')
                },
                showPicker: false,
                showKeyboard: false,
                isLoading: false,
                belongFinType: '',
                belongFinTypes: [],
                showDatePicker: false,
                pickDate:new Date(),
                minDate: DateUtil.getMinDate(),
                maxDate: DateUtil.getMaxDate(),
                showTimePicker: false,
                pickTime:DateUtil.formatDate(new Date,'hh:mm')
            }
        },
        created:function() {
            debugger
            if(!this.formModel.finId){
                this.initData()
            }else{
                this.initAlterData()
            }
        },
        methods:{
            initData(){

                let params = {attrIds:[18,17]}
                this.$axios.post(MyApi.QRY_ATTR_LIST_BY_PARID,params).then((resp) => {
                    let payer = resp.data.payer
                    let type = resp.data.pmType

                    this.belongFinTypes.push({values:payer});
                    this.belongFinTypes.push({values:type});
                    this.belongFinType = payer[0].attrName + " " + type[0].attrName
                    this.formModel.roleId = payer[0].attrId
                    this.formModel.type = type[0].attrNbr

                }).catch((error) => {
                    console.log(error)
                    this.$toast.fail("数据初始化异常");
                })

            },
            onConfirm(value,index) {
                this.formModel.roleId = value[0].attrId;
                this.formModel.type = value[1].attrNbr;
                this.belongFinType = value[0].attrName + " " + value[1].attrName;
                this.showPicker = false;
            },
            submitForm() {
                this.isLoading = true
                // let params = this.model
                // thisVue.buttonDisabled = true
                //let toast = thisVue.showToast()

                let params = this.formModel
                this.$axios.post(MyApi.POCKET_MONTY_SAVE_URL,params/*,options*/)

                    // 请求成功后
                    .then((data) => {
                        //let data = response.data;
                        if('200' == data.code){
                            this.formModel.amount = ''
                            this.formModel.remark = ''
                            this.$toast.success(data.msg);
                        }
                        this.isLoading = false
                    })
                    .catch((err) => {
                        this.$toast.fail("请求异常,请稍后再试");
                    })
            },
            onDateConfirm(value) {
                this.formModel.pmDate = DateUtil.formatDate(value,'yyyy-MM-dd');
                this.showDatePicker = false;
            },
            onTimeConfirm(value) {
                this.formModel.pmTime = value;
                this.showTimePicker = false;
            },
            //是否显示轧账数据
            checkUser(){
              let user = store.state.sys.user
              let isHide = SysCfg.stockIsHide
              if(user.userId == BusiConsts.BELONG_BAO || isHide){
                return false;
              }
              return true;
            }
        }
    }
</script>

<style scoped>

</style>
